/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockMenuEditCtrl
 */
angular.module('mercury.modules.stock.menu')
.controller('StockMenuEditCtrl', ["dialog", "$q", "$resource", "$scope", "$state", "$stateParams", "SalesTax", "StockItems", "StockMenus", "StockRecipes", "title", "settings", function(dialog, $q, $resource, $scope, $state, $stateParams, SalesTax, StockItems, StockMenus, StockRecipes, title, settings) {
  title.set('Edit Menu');

  var PosItemLink = $resource(settings.apiHost + '/r/StockPositemLinks/:id', {id: '@id'});

  var lineOptions = StockItems.getAllWithRecipes();
  lineOptions.then(function(response) {
    lineOptions = response;
  });

  $scope.lineGroups = [];
  $scope.newGroup = '';

  taxRatesLoading = SalesTax.getCompanySalesTaxAmounts();
  taxRatesLoading.then(function(result) {
    $scope.taxRates = result;
  });

  if ($stateParams.id) {
    $scope.menu = StockMenus.get($stateParams.id);

    $scope.loading = $q.all([$scope.menu.$promise, taxRatesLoading]);
    $scope.loading.then(function() {
      angular.forEach($scope.menu.lines, function(line) {
        $scope.priceUpdate(line);

        if (!line.stockItemId && !line.recipeId) {
          $scope.lineGroups.push({
            name: line.name,
            lines: []
          });
        } else {
          $scope.lineGroups[$scope.lineGroups.length - 1].lines.push(line);
        }
      });
    }, function() {
      $state.go('Stock.Menu');
    });
  } else {
    $scope.menu = {};
  }

  $scope.loadingPromises = $q.all([
    lineOptions,
    $scope.menu.$promise,
    taxRatesLoading
  ]);

  $scope.lineOptions = function() {
    var existing = {
      item: {},
      recipe: {}
    };

    angular.forEach($scope.lineGroups, function(group) {
      angular.forEach(group.lines, function(line) {
        if (line.recipeId) {
          existing.recipe[line.recipeId] = true;
        } else if (line.stockItemId) {
          existing.item[line.stockItemId] = true;
        }
      });
    });

    var avaliableOptions = [];
    angular.forEach(lineOptions, function(lineOption) {
      if ((lineOption.isRecipe && !existing.recipe[lineOption.id]) || (!lineOption.isRecipe && !existing.item[lineOption.id])) {
        avaliableOptions.push(lineOption);
      }
    });

    return avaliableOptions;
  };

  /**
   * Save menu if required and return to the menu list screen.
   */
  $scope.save = function() {
    $scope.menuEditForm.$setSubmitted();
    if ($scope.menuEditForm.$invalid) {
      return;
    }

    var menuLines = [];

    var order = 1;
    angular.forEach($scope.lineGroups, function(group) {
      menuLines.push({
        name: group.name,
        price: 0,
        lineOrder: order++
      });

      angular.forEach(group.lines, function(line) {
        line.lineOrder = order++;
        menuLines.push(line);
      });
    });

    $scope.menu.lines = menuLines;

    if ($scope.menu.id) {
      $scope.savingPromise = StockMenus.update($scope.menu);
    } else {
      $scope.savingPromise = StockMenus.create($scope.menu);
    }

    $scope.savingPromise.then(function() {
      if ($stateParams.id) {
        $state.go('Stock.MenuView', {id: $scope.menu.id});
      } else {
        $state.go('Stock.Menu');
      }
    });
  };

  /**
   * Add new menu item to the current menu
   */
  $scope.addItem = function(group, item) {
    if (item.isRecipe) {
      var newLineRecipe = {
        name: item.name,
        recipeId: item.id
      };

      StockRecipes.getCostAndUnit(item.id)
      .then(function(result) {
        newLineRecipe.currentPrice = result.currentPrice;
        newLineRecipe.stockUnitRatio = result.currentVersion.yeildUnitRatio;
        newLineRecipe.price = newLineRecipe.currentPrice * newLineRecipe.stockUnitRatio;

        $scope.priceUpdate(newLineRecipe);
        group.lines.push(newLineRecipe);
      });
    } else {
      var newLineItem = {
        name: item.name,
        stockItemId: item.id,
        currentPrice: item.currentPrice,
        stockUnitRatio: item.unitRatio,
        price: item.currentPrice * item.unitRatio,
        salesTaxRateId: item.salesTaxRateId
      };

      $scope.priceUpdate(newLineItem);
      group.lines.push(newLineItem);
    }
  };

  /**
   * Delete a menu item.
   */
  $scope.deleteItem = function(index, group) {
    group.splice(index, 1);
  };

  $scope.deleteItemGroup = function(index) {
    $scope.lineGroups.splice(index, 1);
  };

  $scope.addGroup = function() {
    $scope.lineGroups.push({
      name: angular.copy($scope.newGroup),
      lines: []
    });

    $scope.newGroup = '';
  };

  /**
   * Update the cogs based on the current price
   *
   * @param {Object} line - Menu line to update
   */
  $scope.priceUpdate = function(line) {
    if (line.price) {
      var salesTaxRate = SalesTax.getCompanySalesTaxRate($scope.taxRates, line.salesTaxRateId || 1);
      line.cogs = ((line.currentPrice * parseFloat(line.stockUnitRatio)) / (line.price / salesTaxRate));
    } else {
      line.cogs = 0;
    }
  };

  /**
   * update the price based on the current cogs

   * @param {Object} line - Menu line to update
   */
  $scope.cogsUpdate = function(line) {
    if (line.cogs) {
      var salesTaxRate = SalesTax.getCompanySalesTaxRate($scope.taxRates, line.salesTaxRateId || 1);
      line.price = ((line.currentPrice * parseFloat(line.stockUnitRatio)) / line.cogs) * salesTaxRate;
    } else {
      line.price = 0;
    }
  };

  $scope.posLinksDialog = function(line) {
    if (line.stockItemId) {
      $scope.posLinks = PosItemLink.query({stockItemId: line.stockItemId});
    } else {
      $scope.posLinks = PosItemLink.query({recipeId: line.recipeId});
    }

    $scope.linksStockItem = line.name;

    dialog.open({
      templateUrl: 'modules/stock/menu/positemlinks.tpl.html',
      scope: $scope
    });
  };
}]);
